module.exports = __webpack_public_path__ + "img/partner12.365a03f0.png";